import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const FinalCTASection = () => {
  const navigate = useNavigate();

  return (
    <section className="relative py-32 px-4 bg-black">
      {/* Background Blobs */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-luxury-pink/20 rounded-full blur-[120px]" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-luxury-lightPurple/20 rounded-full blur-[120px]" />
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative z-10 max-w-4xl mx-auto text-center"
      >
        <h2 className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple bg-clip-text text-transparent">
          Pronto para viver conexões de verdade?
        </h2>
        <p className="text-xl md:text-2xl text-white/60 mb-12 max-w-3xl mx-auto">
          Sugar Daddies, Sugar Mommies e Sugar Babies que valorizam clareza já estão aqui.
        </p>
        <Button
          size="lg"
          variant="brand-gradient"
          onClick={() => navigate('/auth')}
          className="text-lg px-12 py-7"
        >
          Criar minha conta
        </Button>
      </motion.div>
    </section>
  );
};

export default FinalCTASection;
